const ATTRIBUTE_LINK_CARD = 'data-klt-c-link-card';

export default init;

/**
 * Adds a redundant click event to any cards that have the
 * ATTRIBUTE_LINK_CARD attribute, to allow clicking the whole
 * card without sacrificing the accessibility for screen readers and
 * keyboard users by still allowing focus and clicks on the individual
 * links in the card.
 * @deprecated Use card.stimulus.ts
 * @see https://inclusive-components.design/cards/
 */
export function init() {
    const cards = document.querySelectorAll(`[${ATTRIBUTE_LINK_CARD}]`);

    Array.prototype.forEach.call(cards, (card) => {
        // We just assume the first link we hit, mostly the title of the card,
        // being the main link for the whole card click.
        const link = card.querySelector('a');
        let down;
        let up;

        if (link) {
            card.style.cursor = 'pointer';

            // Use mouseup/mousedown events instead of click events
            // to allow the user to still mark text in the card.
            card.onmousedown = () => (down = +new Date());
            card.onmouseup = (e: MouseEvent) => {
                up = +new Date();
                if (up - down < 200) {
                    // Resolve any issues with the link being opened twice by checking if the user
                    // clicks some other link in the card. If there are other links and the user clicks
                    // them, we just entirely stop the
                    if (!(e.target as HTMLAnchorElement).href) {
                        link.click();
                    }
                }
            };
        }
    });
}
